export default __webpack_public_path__ + "static/media/regalo.cd51503b.png";